import { defineComponent as _defineComponent } from 'vue';
import AdminLayout from '@/Layouts/Admin.vue';
import { Head } from '@inertiajs/inertia-vue3';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import DataTable from '@/Components/DataTable.vue';
import Column from 'primevue/column';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import Slider from 'primevue/slider';
import MultiSelect from 'primevue/multiselect';
import ModelSidebar from '@/Components/ModelSidebar.vue';
import CompanyForm from '../../Company/Form.vue';
import { ref } from 'vue';
import { useRoute } from '../../../Plugins/ziggy';
import { useSpinner } from '../../../Plugins/spinner';
import CompanyService from '../../../Services/CompanyService';
import GroupActions from '../../../Components/GroupActions.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Index',
    props: {
        companies: Array,
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const companyService = new CompanyService();
        const route = useRoute();
        const spinner = useSpinner();
        const companies = props.companies;
        const loading = ref(false);
        const selectedCity = ref(null);
        const groupActions = ref([
            {
                label: 'Elimina Selezionati',
                command: () => { },
            },
        ]);
        const selectedCompanies = ref([]);
        const filters = ref({
            global: { value: '', matchMode: FilterMatchMode.CONTAINS },
            name: {
                operator: FilterOperator.AND,
                constraints: [{ value: '', matchMode: FilterMatchMode.STARTS_WITH }],
            },
            'country.name': {
                operator: FilterOperator.AND,
                constraints: [{ value: '', matchMode: FilterMatchMode.STARTS_WITH }],
            },
            status: { value: '', matchMode: FilterMatchMode.IN },
            users: { value: '', matchMode: FilterMatchMode.BETWEEN },
            plants: { value: '', matchMode: FilterMatchMode.BETWEEN },
        });
        const activationStatuses = [{ name: 'Attivo' }, { name: 'Non Attivo' }];
        const editRecordData = ref(null);
        const formVisible = ref(false);
        const openForm = (data = {}) => {
            editRecordData.value = data;
            formVisible.value = true;
        };
        const closeForm = () => (formVisible.value = false);
        const create = () => {
            openForm();
        };
        const edit = (id) => {
            spinner.show();
            companyService
                .show(id)
                .then((res) => openForm(res.data.data))
                .finally(() => spinner.hide());
        };
        if (location.hash === '#add') {
            console.log(location.hash);
            setTimeout(() => {
                history.replaceState(null, document.title, window.location.pathname + window.location.search);
            });
            create();
        }
        const __returned__ = { props, companyService, route, spinner, companies, loading, selectedCity, groupActions, selectedCompanies, filters, activationStatuses, editRecordData, formVisible, openForm, closeForm, create, edit, AdminLayout, get Head() { return Head; }, get InputText() { return InputText; }, get Button() { return Button; }, DataTable, get Column() { return Column; }, get MultiSelect() { return MultiSelect; }, ModelSidebar, CompanyForm, GroupActions };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
